import { SideDrawer } from "@/components/common/SideDrawer";
import { CompactTaskList } from "@/resources/tasks/components/task-list/CompactTaskList";
import { TaskDetailsDialog } from "@/resources/tasks/components/task-dialogs/TaskDetailsDialog";
import { useState } from "react";
import { useRecordContext } from "react-admin";
import { ObjectType, Task, TaskRecordReference } from "@/types";
import { TaskComposerInline } from "@/resources/tasks/components/task-list/TaskComposerInline";

interface StoplossClaimSideDrawerProps {
  drawerExpanded: boolean;
  toggleDrawer: () => void;
}

export const StoplossClaimSideDrawer: React.FC<StoplossClaimSideDrawerProps> = ({ drawerExpanded, toggleDrawer }) => {
  const stoplossClaim = useRecordContext();
  const [refreshKey, setRefreshKey] = useState(0);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<Task | undefined>();

  if (!stoplossClaim) return null;

  const recordRef = {
    object_type: ObjectType.STOPLOSS_CLAIMS as const,
    object_id: stoplossClaim.id, // ensure this matches what tasks store
    label: stoplossClaim.aegle_id,
  } as TaskRecordReference;

  return (
    <>
      <SideDrawer title="Tasks" open={drawerExpanded} onClose={toggleDrawer} hideHandle>
        {/* Inline add, bound to this claimant */}
        <TaskComposerInline
          record={recordRef}
          onCreated={() => setRefreshKey((k) => k + 1)} // Enter creates new Task
          open={drawerExpanded}
        />

        {/* List */}
        <CompactTaskList
          key={refreshKey} // <-- forces fresh fetch after create
          recordRef={recordRef} // <-- filter to this claimant’s tasks
          onTaskClick={(task: Task) => {
            // <-- open details on row click
            setSelected(task);
            setOpen(true);
          }}
        />
      </SideDrawer>

      <TaskDetailsDialog open={open} task={selected} onClose={() => setOpen(false)} />
    </>
  );
};
